export default function getIsOnlySingleIcon(_a) {
    var children = _a.children, iconBefore = _a.iconBefore, iconAfter = _a.iconAfter;
    if (children) {
        return false;
    }
    if (iconBefore && !iconAfter) {
        return true;
    }
    if (!iconBefore && iconAfter) {
        return true;
    }
    return false;
}
//# sourceMappingURL=get-is-only-single-icon.js.map